//dev.to/thelamina/handling-network-status-in-your-react-app-4222

import { DisconnectOutlined } from '@ant-design/icons';
import { Space, Typography, theme } from 'antd';
import { memo, useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import useNavigatorOnLine from '../hooks/useNavigatorOnline';
import { grispiNotification } from '../store/useNotificationStore';

/* The `NetworkStatusController` component is a functional component in TypeScript React. It is
responsible for handling the network status of the application and displaying a warning message when
the network is offline. */
const NetworkStatusController = () => {
    const isOnline = useNavigatorOnLine();
    const networkStatus = useRef(true);
    const { t } = useTranslation('error');
    const {
        token: { zIndexPopupBase, colorErrorText }
    } = theme.useToken();

    useLayoutEffect(() => {
        if (isOnline !== networkStatus.current) {
            isOnline
                ? grispiNotification('info', t('networkError.online'), 'info')
                : grispiNotification('error', t('networkError.offline'), 'error');
        }
        networkStatus.current = isOnline;
    }, [isOnline, t]);

    return (
        <>
            {!isOnline ? (
                <Space
                    style={{ position: 'absolute', width: '0', height: '0', zIndex: zIndexPopupBase + 1 }}
                    className="full-width"
                >
                    <Space
                        style={{
                            position: 'relative',
                            top: '50vh',
                            left: '50vw',
                            alignItems: 'center',
                            transform: 'translateX(-50%)'
                        }}
                        direction="vertical"
                    >
                        <DisconnectOutlined style={{ fontSize: '250%', color: colorErrorText }} />
                        <Typography.Title level={4} style={{ color: colorErrorText }}>
                            {t('networkError.warning')}
                        </Typography.Title>
                    </Space>
                </Space>
            ) : null}
        </>
    );
};
export default memo(NetworkStatusController);
